/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * KeyValue pair to store values in the health info strings in health show response
 */
export interface DescriptionsKeyValue { 
    key: string;
    value: string;
}

